import request from '@/utils/request'
import { ConstConfig } from '@/utils'

export function getMatchList(data) {
  return request({
    url: ConstConfig.apiPath + '/GetMatchList.json',
    method: 'post',
    data
  })
}

export function getMatchGroupList(data) {
  return request({
    url: ConstConfig.apiPath + '/GetMatchGroupList.json',
    method: 'post',
    data
  })
}

export function getMatchGroupScoreRank(data) {
  return request({
    url: ConstConfig.apiPath + '/GetMatchGroupScoreRank.json',
    method: 'post',
    data
  })
}

export function getPlayerList(data) {
  return request({
    url: ConstConfig.apiPath + '/GetPlayerList.json',
    method: 'post',
    data
  })
}

export function getCoachList(data) {
  data.pageSize = 9999
  return request({
    url: ConstConfig.apiPath + '/GetCoachList.json',
    method: 'post',
    data
  })
}

export function createTeam(data) {
  return request({
    url: ConstConfig.apiPath + '/CreateTeam.json',
    method: 'post',
    data
  })
}

export function organizationTeamSighUpMatchGroup(data) {
  return request({
    url: ConstConfig.apiPath + '/OrganizationTeamSighUpMatchGroup.json',
    method: 'post',
    data
  })
}

export function getOrganizationTeamList(data) {
  return request({
    url: ConstConfig.apiPath + '/GetOrganizationTeamList.json',
    method: 'post',
    data
  })
}

export function updateTeam(data) {
  return request({
    url: ConstConfig.apiPath + '/UpdateTeam.json',
    method: 'post',
    data
  })
}

export function getTeam(data) {
  return request({
    url: ConstConfig.apiPath + '/GetTeam.json',
    method: 'post',
    data
  })
}

export function updateTeamCoaches(data) {
  return request({
    url: ConstConfig.apiPath + '/UpdateTeamCoaches.json',
    method: 'post',
    data
  })
}

export function updateTeamPlayers (data) {
  return request({
    url: ConstConfig.apiPath + '/UpdateTeamPlayers.json',
    method: 'post',
    data
  })
}

export function addTeamPlayers (data) {
  return request({
    url: ConstConfig.apiPath + '/AddTeamPlayers.json',
    method: 'post',
    data
  })
}

export function deleteTeamPlayer (data) {
  return request({
    url: ConstConfig.apiPath + '/DeleteTeamPlayer.json',
    method: 'post',
    data
  })
}

export function getOrganizationInvolvedMatchList (data) {
  return request({
    url: ConstConfig.apiPath + '/GetOrganizationInvolvedMatchList.json',
    method: 'post',
    data
  })
}

export function getOrganizationGroupTeamList (data) {
  return request({
    url: ConstConfig.apiPath + '/GetOrganizationGroupTeamList.json',
    method: 'post',
    data
  })
}

export function getGroupTeam (data) {
  return request({
    url: ConstConfig.apiPath + '/GetGroupTeam.json',
    method: 'post',
    data
  })
}

export function exportTeamData(data) {
  return request({
    url: ConstConfig.apiPath + '/api/content/pc/ExportTeam.json',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/match.js